// extracted by mini-css-extract-plugin
export default {"OnTelemetry":"ServiceCard_OnTelemetry__oA5Uv","OnRemote":"ServiceCard_OnRemote__wFGkg","OnIvtouch":"ServiceCard_OnIvtouch__KnFY9"};